module.exports = __webpack_public_path__ + "static/media/strava.972caff0.svg";